<template>

<AppTopBar  /> 

 <div class="container-fluid">
    <div class="row">
       
      <div class="col-12" style="margin-top: 60px">
        <router-view></router-view>
      </div>
    </div>
  </div>
<!-- <div class="jumbotron">
        <div class="container text-center">
            <div class="row">
                <div class="col-sm-8 offset-sm-2">
                    <div v-for="(message, index) in messages" :key="index" class="alert alert-success">{{message.text}}</div>
                    
                </div>
            </div>
        </div>
    </div>
 -->
<VueLoading :active="isLoading"></VueLoading>
</template>
<style scoped>
body {
  background-color: black;
}
</style>
<script>
// import Agent from './components/Agent.vue'
 import AppTopBar from "./AppTopbar.vue";
 
import Appservice from "./service/Appservice";
 //import { messageService } from '@/service';
export default {
  name: "App",
   components: {
    AppTopBar: AppTopBar,
    
  },
  data() {
    return {
      messages: [],
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
      //return false;
    },
   user() {
     return this.$store.state.user;
    },
     clientId() {
     return this.$store.state.user?.clientId;
    },
  },
  appservice: null,
  created() {
    // this.$store.commit('Set_ClientId', 'A385C776-9A75-4D1B-92D1-FF518306CD2F')

    this.appservice = new Appservice();
    // subscribe to home component messages
     /* this.subscription = messageService.getMessage().subscribe((message) => {
      if (message) {
        // add message to local state if not empty
        this.messages.push(message);
      } else {
        // clear messages when empty message received
        this.messages = [];
      }
    });   */
    this.$router.push('/home') // 页面加载时跳转
  },
  beforeUnmount() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
